export default {
  checkChar (charCode) {
    if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
      return false
    }

    return true
  },

  checkNumber (fieldType, inputValue) {
    const res = {
      valid: false
    }

    const inputString = inputValue.toString()

    const fraction = Number(inputString.split('.')[1])

    const fractionLength = inputString.split('.')[1].length

    if (!inputValue) {
      res.message = 'Field is required'
    }
    const dotsOccurance = (inputString.match(/\./g) || []).length

    if (inputString.indexOf('.') === inputString.length - 1 || dotsOccurance > 1) {
      res.message = 'Field is invalid'
    }

    if (fieldType === 'budget') {
      if (inputValue > 9999999 && inputString.indexOf('.') === -1) {
        res.message = 'Number must not exceed 9999999'
      } else if (inputValue > 99999.99 && inputString.indexOf('.') !== -1) {
        res.message = 'Number must not exceed 99999.99'
      } else if (fraction > 99 || fractionLength > 2) {
        res.message = 'Fraction must not exceed 2 numbers'
      }
    } else if (fieldType === 'bidding') {
      if (inputValue > 9999999 && inputString.indexOf('.') === -1) {
        res.message = 'Number must not exceed 9999999'
      } else if (inputValue > 9999.999  && inputString.indexOf('.') !== -1) {
        res.message = 'Value must not exceed 9999.999'
      } else if (fraction > 999 || fractionLength > 3) {
        res.message = 'Fraction must not exceed 3 numbers'
      }
    }

    if (!res.message) {
      res.valid = true
    }

    return res
  }
}
